import { z } from "zod"

export const UpdateCustomerCommentSchema = z.object({
  jobId: z.string(),
  content: z.string(),
})

export type UpdateCustomerComment = z.infer<typeof UpdateCustomerCommentSchema>

export const CustomerCommentSchema = z.object({
  comment: z.string().nullable(),
})

export type CustomerComment = z.infer<typeof CustomerCommentSchema>
